import { render, staticRenderFns } from "./myAttention.vue?vue&type=template&id=6ebd1b84&scoped=true"
import script from "./myAttention.vue?vue&type=script&lang=js"
export * from "./myAttention.vue?vue&type=script&lang=js"
import style0 from "./myAttention.vue?vue&type=style&index=0&id=6ebd1b84&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebd1b84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ebd1b84')) {
      api.createRecord('6ebd1b84', component.options)
    } else {
      api.reload('6ebd1b84', component.options)
    }
    module.hot.accept("./myAttention.vue?vue&type=template&id=6ebd1b84&scoped=true", function () {
      api.rerender('6ebd1b84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/page/myAttention.vue"
export default component.exports